import Component from '../components/component';

class Page extends Component {
  constructor({ resource }) {
    super();
    this._resource = resource;
  }
}
export default Page;
